<template><div><h1 id="aktionen-stammdaten" tabindex="-1"><a class="header-anchor" href="#aktionen-stammdaten"><span>Aktionen Stammdaten</span></a></h1>
<p>Stammtabelle — Einstellungen zu den Aktionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Stammtabelle werden die Aktionen parametrisiert.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Aktionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Aktion</dt>
<dd>
<p>Bezeichnung/Code der Aktion (nicht editierbar).</p>
</dd>
<dt>Status (optional)</dt>
<dd>
<p>Status der Aktion. Ist mit fest programmierten Prozessen verknüpft und deshalb nicht bei allen Organisationen verfügbar.</p>
</dd>
<dt>Beschreibung</dt>
<dd>
<p>Beliebiger Beschreibungstext.</p>
</dd>
<dt>w. Quellen</dt>
<dd>
<p>Umsatz in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;Weitere Quellen&quot; akkummulieren?<br>&quot;+&quot; = Betrag aufsummieren<br>&quot;-&quot; = Betrag subtrahieren<br>&quot; &quot; = Betrag wird für &quot;weitere Quellen&quot; nicht berücksichtigt</p>
</dd>
<dt>eingereicht</dt>
<dd>
<p>Umsatz in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;eingereicht&quot; akkummulieren?<br>Gleiche Werte verfügbar wie oben beschrieben.</p>
</dd>
<dt>zugesagt</dt>
<dd>
<p>Umsatz in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;zugesagt&quot; akkummulieren?<br>Gleiche Werte verfügbar wie oben beschrieben.</p>
</dd>
<dt>abgesagt</dt>
<dd>
<p>Umsatz in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;abgesagt&quot; akkummulieren?<br>Gleiche Werte verfügbar wie oben beschrieben.</p>
</dd>
<dt>erwartet</dt>
<dd>
<p>Umsatz in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;erwartet&quot; akkummulieren?<br>Gleiche Werte verfügbar wie oben beschrieben.</p>
</dd>
<dt>Prognose</dt>
<dd>
<p>Prognosebetrag in <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a> unter &quot;Prognose&quot; anzeigen?<br>Gleiche Werte verfügbar wie oben beschrieben.</p>
</dd>
<dt>Frame-Typ</dt>
<dd>
<p>Definiert, mit welchem Frame die Aktion erfasst/mutiert wird. So kann z.B. ausgeschlossen werden, dass für ein Telefonat ein Projekt oder ein Bertrag eingetragen werden muss. Folgende Frametypen stehen zur Auswahl:</p>
<table>
<thead>
<tr>
<th>Frame-Typ</th>
<th>Anwendung</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>mit Betraegen und MF</td>
<td>Custom (nur WWF)</td>
<td>Erfassung von mehreren Teilbeträgen/Perioden in eiener einzelnen Aktion möglich. Erfassung und Verwaltung von Management Fee.</td>
</tr>
<tr>
<td>mit Betrag, ohne Prognose</td>
<td>allgemein</td>
<td>Betrag kann erfasst werden. Feld für Prognose nicht verfügbar.</td>
</tr>
<tr>
<td>mit Betrag und Prognose</td>
<td>allgemein</td>
<td>Betrag kann erfasst werden. Feld für Prognose verfügbar.</td>
</tr>
<tr>
<td>ohne Betrag</td>
<td>allgemein</td>
<td>Für Aktionen, wo kein Betrag erfasst werden soll (z.B. &quot;Telefon, &quot;Reklamation&quot; oder &quot;Meeting&quot;). Der Projekteintrag ist hier nicht zwingend.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Sammelnummer erfassen</dt>
<dd>
<p>Parameter für die Steuerung der Sammelnummer bei der Erfassung einer Aktion (immer zusammen mit Feld &quot;bestehende übernehmen&quot; betrachten!).</p>
<table>
<thead>
<tr>
<th>ja</th>
<th>nein</th>
<th>optional</th>
</tr>
</thead>
<tbody>
<tr>
<td>es wird immer eine Sammelnummer erfasst</td>
<td>es wird nie eine Sammelnummer erfasst</td>
<td>der Benutzer entscheidet bei der Aktionserfassung, ob eine Sammelnummer erfasst werden soll</td>
</tr>
</tbody>
</table>
</dd>
<dt>bestehende (&quot;Sammelnummer&quot;) übernehmen</dt>
<dd>
<p>Parameter für die Steuerung der Sammelnummer bei der Erfassung einer Aktion (immer zusammen mit Feld &quot;Sammelnummer erfassen&quot; betrachten!).</p>
<table>
<thead>
<tr>
<th>ja</th>
<th>nein</th>
<th>optional</th>
</tr>
</thead>
<tbody>
<tr>
<td>die Sammelnummer der Aktion, auf der man steht, wird übernommen</td>
<td>es wird keine vorbestehende Sammelnummer übernommen</td>
<td>der Benutzer entscheidet bei der Aktionserfassung, ob eine vorbestehende Sammelnummer übernommen werden soll</td>
</tr>
</tbody>
</table>
<p>Kombinationen der Sammelnummer-Parametrisierung:<div class="mediaobject"><img src="@source/referenz/i/Sammelnummer.jpg"></div></p>
</dd>
<dt>manuelle Erfassung</dt>
<dd>
<p>Bestimmt, ob Aktionen manuell erfasst werden können oder nur automatisch durch das System. Die automatische Erfassung kann programmgesteuert erfolgen oder durch einen Eintrag im Systemparameter &quot;terkopfProjakt&quot; (nur für Spendenzahlungen).</p>
</dd>
<dt>verknüpfen mit OE</dt>
<dd>
<p>Mit der Option &quot;ja&quot; hinterlegte Aktionen werden prinzipiell mit der <a class="link" href="OrganisatorischeEinheiten.html" title="4. Organisatorische Einheiten">Organsiatorischen Einheit</a> des Aktionserfassers abgespeichert.</p>
</dd>
<dt>für Feedbackmanagement (optional)</dt>
<dd>
<p>Mit der Option &quot;ja&quot; hinterlegte Aktionen werden in der &quot;Feedback&quot;-Erfassung vorgeschlagen (nicht bei allen Organisationen verfügbar).</p>
</dd>
<dt>Verwendung in</dt>
<dd>
<p>&quot;Markiert&quot; die Aktion für die Verwendung in einem bestimmtenn Bereich (momentan nur für Nachlass).</p>
</dd>
<dt>I-Status bei der Person</dt>
<dd>
<p>Beendet oder erfasst den Personen-Status &quot;I&quot;, wenn zu einer Person eine Aktion mit diesem Parameter erfasst wird.</p>
</dd>
<dt>Farbe</dt>
<dd>
<p>Aktionen werden in Tabellen mit der gewählten Farbe angezeigt.</p>
</dd>
<dt>Betrag</dt>
<dd>
<p>Kumulierter Wert aller Beträge, die im System für diese Aktion erfasst wurden.</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunkionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink> , <RouteLink to="/manual/administration/organisatorische_einheiten.html" title="4. Organisatorische Einheiten">Organsiatorische Einheiten</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekte</RouteLink></p>
</div></template>


